import { Container } from "@mui/material";
import { useEffect } from "react";
import Page from "../../Components/MetaPage/Page";
import OtpVerify from "../../Components/OtpVerify/OtpVerify";
import { sendEvent } from "../../Utils/analytics";
import { getRemoteValue } from "../../Utils/firebase";

export default function VerifyPage() {
  useEffect(() => {
    sendEvent(`view_validate_otp_page`, {});
  }, []);

  return (
    <Page title={getRemoteValue("entrance")}>
      <Container
        sx={{
          display: "flex",
          minHeight: "auto",
          flexDirection: "column",
          justifyContent: "center",
          paddingTop: "32px",
          paddingBottom: "48px",
          "@media (min-width: 768.5px)": {
            minHeight: "calc(90vh)",
            paddingTop: 0,
            paddingBottom: 0,
          },
        }}
      >
        <OtpVerify />
      </Container>
    </Page>
  );
}
